import { RootState } from "@src/reducers/store";
import React from "react";
import { useSelector } from "react-redux";

import styles from "./my-blueprint-library-modal.module.scss";
import { GlassyModal } from "../../glassy-modal/glassy-modal";
import { FindMyBlueprintLibraryModalContent } from "./find-my-blueprint-library-modal-content/find-my-blueprint-library-modal-content";
import { ApplyMyBlueprintLibraryModalContent } from "./apply-selected-blueprint-content/apply-my-blueprint-library-modal-content";

const cssClassName = "my-blueprint-library-modal";

export const MyBlueprintLibraryModal = () => {
  const myBlueprintLibraryContentShown = useSelector(
    (state: RootState) =>
      state.yourSlice.myBlueprintLibraryModal
        .myBlueprintLibraryModalContentShown,
  );

  const renderFindOrReplaceBlueprintModalContent = (value) => {
    switch (value) {
      case "find":
        return <FindMyBlueprintLibraryModalContent />;
      case "apply":
        return <ApplyMyBlueprintLibraryModalContent />;
      default:
        return <FindMyBlueprintLibraryModalContent />;
    }
  };

  return (
    <GlassyModal>
      <div className={styles[cssClassName]}>
        {renderFindOrReplaceBlueprintModalContent(
          myBlueprintLibraryContentShown,
        )}
      </div>
    </GlassyModal>
  );
};
